import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-status-timer-archive',
  templateUrl: './status-timer-archive.component.html',
  styleUrls: ['../parts.css']
})
export class StatusTimerArchiveComponent implements OnInit {

  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据

  // 定时
  schedulerConditionDisplayText = '定时'; // 定时默认文字
  schedulerConditionData: any; // 存放定时数据
  schedulerConditionVisible: boolean; // 定时pop是否关闭

  statusColumnDisplayText = '状态'; // 状态列显示文字
  statusPopVisible = false; // 状态列pop显示
  statusColumnList = []; // 状态列可选值

  columnValueDisplayText = '某个值'; // 状态列的值的默认文字
  columnValuePopVisible = false; // 状态列值pop显示
  columnValueList = []; // 状态列值可选择值

  recipeId = null; // 自动化模板ID
  relationId;
  categorieId: string;
  instanceData: any = {}; // 存放实例返填数据
  automation = {
    boardId: '',
    columnId: '',
    categoryId: '',
    relationId: '',
    groupId: '',
    targetGroupId: '',
    email: null,
    siteMessage: null,
    sms: null,
    columnValue: {
      index: null,
      indexes: []
    },
    receiver: {
    },
    instanceDescription: '',
    schedulerDescription: '',
    schedulerConfig: {},
    conditions: [{}],
    pulseMapping: {}
  };
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      if (this.boardColumnData && this.boardColumnData.length > 0) {
        for (let column of this.boardColumnData) {
          if (column.type === 'status') {
            this.statusColumnList.push(column);
          }
        }
      }
    }
    // 初始化自动化数据
    if (this.instanceData && this.instanceData.config) {
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.schedulerConditionData = this.instanceData.config.schedulerConfig;
      this.schedulerConditionDisplayText =
        this.instanceData.config.schedulerDescription ? this.instanceData.config.schedulerDescription : '定时';
      if (this.automation.columnId && this.statusColumnList.length > 0) {
        for (const statusColumn of this.statusColumnList) {
          if (statusColumn.id === this.automation.columnId) {
            this.statusColumnDisplayText = statusColumn.title;
            this.columnValueList = statusColumn.labels;
            for (let label of this.columnValueList) {
              if (label.index === this.automation.columnValue.index) {
                this.columnValueDisplayText = label.label;
                break;
              }
            }
            break;
          }
        }
      }
      this.getStatusValueText();
    }
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.packageData();
  }

  // 获取定时数据
  getSchedulerData(event) {
    this.schedulerConditionVisible = false;
    this.schedulerConditionDisplayText = event.text;
    this.schedulerConditionData = event.config;
    this.automation.schedulerDescription = this.schedulerConditionDisplayText;
    this.automation.schedulerConfig = this.schedulerConditionData;
    this.packageData();
  }

  statusSelectChange(item) {
    this.statusColumnDisplayText = item.title;
    this.automation.columnId = item.id;
    this.statusPopVisible = false;
    this.columnValueList = item.labels;
    this.automation.columnValue.index = null;
    this.columnValueDisplayText = '某个值';
    this.packageData();
  }

  columnValueSelectChange(item) {
    let i = this.automation.columnValue.indexes.findIndex((index) => index == item.index);
    if (i > -1) {
      this.automation.columnValue.indexes.splice(i, 1);
    } else {
      this.automation.columnValue.indexes.push(item.index);
    }
    this.getStatusValueText();
    this.packageData();
  }

  getStatusValueText() {
    let texts = [];
    for (let item of this.columnValueList) {
      if (this.automation.columnValue.indexes.includes(item.index)) {
        texts.push(item.label);
      }
    }
    this.columnValueDisplayText = texts.join('或');
  }

  packageData() {
    this.automation.instanceDescription = this.schedulerConditionDisplayText  + '，当 ' + this.statusColumnDisplayText
      + ' 变更为 ' + this.columnValueDisplayText + ' 时，归档该任务 ';
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus() : boolean {
    return JSON.stringify(this.automation.schedulerConfig) !== '{}' &&
      this.automation.columnId &&
      this.automation.columnValue.indexes != null && this.automation.columnValue.indexes.length > 0;
  }
}
